<template>
  <div class="pinwall _flxccc">
    <header class="pinwall-header" id="modalTitle">
      <span class="txt-bold">PINWALL</span>
        <button type="button" class="btn-close" title="Close" @click.stop.prevent="$emit('close')" aria-label="Close modal">
          <i class="material-icons icon" style="font-size:22px!important">close</i>
        </button>
    </header>
    <div class="pinwall__load _flxcs">
      <assets v-on:inputAsset="updateAsset" v-if="selectedPinwall.visible" :type="type"></assets>
      <list v-if="!selectedPinwall.visible" :items="pinwalls" v-on:refresh="loadPinwalls()"></list>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import List from './list'
import Assets from './assets'

export default {
  name: 'pinwall',
  components: {List, Assets},
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(['pinwalls', 'selectedPinwall', 'user'])
  },
  methods: {
    ...mapActions(['loadPinwalls']),
    updateAsset(event) {
      this.$emit('inputAsset', event)
    }
  },
  created() {
    this.loadPinwalls()
  }
}

</script>
